module.exports = __webpack_public_path__ + "static/media/Alicia Zhong.3bcdd53e.png";